import React from "react";
import WindowFrame from "../components/WindowFrame";
import TimelineWindowContent from "../components/TimelineWindowContent";
import ComparativeWindowContent from "../components/ComparativeWindowContent";
import StacksWindowContent from "../components/StacksWindowContent";
import MethodWindowContent from "../components/MethodWindowContent";
import MantraWindowContent from "../components/MantraWindowContent";
import IAOperationalWindowContent from "../components/IAOperationalWindowContent";
import GitflowWindowContent from "../components/GitflowWindowContent";
import ProjectWindowContent from "../components/ProjectWindowContent";
import ResumeWindowContent from "../components/ResumeWindowContent";
import ContactWindowContent from "../components/ContactWindowContent";

export function renderWindowById({
  windowId,
  mobileModal = false,
  focusedWindow,
  flashWindow,
  maximizedWindow,
  minimizedWindows,
  setFocusedWindow,
  closeWindowForCurrentViewport,
  toggleMinimizeWindow,
  toggleMaximizeWindow,
  registerWindowRef,
  localizedProjectsById,
  localizedTimelineData,
  localizedProjects,
  summary,
  onOpenProjectWindow,
  t,
}) {
  const commonProps = {
    windowId,
    focusedWindow,
    flashWindow,
    maximizedWindow: mobileModal ? windowId : maximizedWindow,
    onFocus: setFocusedWindow,
    onClose: closeWindowForCurrentViewport,
    minimizedWindows,
    onToggleMinimize: toggleMinimizeWindow,
    onToggleMaximize: toggleMaximizeWindow,
    registerRef: mobileModal ? () => {} : registerWindowRef,
    showMinimize: !mobileModal,
    showMaximize: !mobileModal,
  };

  if (windowId.startsWith("project-")) {
    const projectId = windowId.replace("project-", "");
    const project = localizedProjectsById[projectId];
    if (!project) {
      return null;
    }

    return (
      <WindowFrame key={`project-window-${project.id}`} title={project.name} className="projectWindow" {...commonProps}>
        <ProjectWindowContent project={project} isMaximized={mobileModal || maximizedWindow === `project-${project.id}`} />
      </WindowFrame>
    );
  }

  if (windowId.startsWith("resume_")) {
    return (
      <WindowFrame key={`resume-window-${windowId}`} title={t(`windows.${windowId}.title`)} {...commonProps}>
        <ResumeWindowContent sectionId={windowId} />
      </WindowFrame>
    );
  }

  if (windowId === "timeline") {
    return (
      <WindowFrame key={windowId} title={t("windows.timeline.title")} {...commonProps}>
        <TimelineWindowContent timelineData={localizedTimelineData} onOpenProjectWindow={onOpenProjectWindow} />
      </WindowFrame>
    );
  }

  if (windowId === "comparativo") {
    return (
      <WindowFrame key={windowId} title={t("windows.comparativo.title")} className="wide" {...commonProps}>
        <ComparativeWindowContent summary={summary} projects={localizedProjects} />
      </WindowFrame>
    );
  }

  if (windowId === "stacks") {
    return (
      <WindowFrame key={windowId} title={t("windows.stacks.title")} {...commonProps}>
        <StacksWindowContent projects={localizedProjects} />
      </WindowFrame>
    );
  }

  if (windowId === "metodo") {
    return (
      <WindowFrame key={windowId} title={t("windows.metodo.title")} {...commonProps}>
        <MethodWindowContent isMaximized={mobileModal || maximizedWindow === "metodo"} />
      </WindowFrame>
    );
  }

  if (windowId === "mantra") {
    return (
      <WindowFrame key={windowId} title={t("windows.mantra.title")} {...commonProps}>
        <MantraWindowContent />
      </WindowFrame>
    );
  }

  if (windowId === "ia_operacional") {
    return (
      <WindowFrame key={windowId} title={t("windows.ia_operacional.title")} {...commonProps}>
        <IAOperationalWindowContent />
      </WindowFrame>
    );
  }

  if (windowId === "gitflow") {
    return (
      <WindowFrame key={windowId} title={t("windows.gitflow.title")} {...commonProps}>
        <GitflowWindowContent />
      </WindowFrame>
    );
  }

  if (windowId === "portfolio_contact") {
    return (
      <WindowFrame key={windowId} title={t("windows.portfolio_contact.title")} {...commonProps}>
        <ContactWindowContent />
      </WindowFrame>
    );
  }

  return null;
}
